module.exports = __webpack_public_path__ + "img/want_sale.c94395db.svg";